export const SAUNA_TYPES: { value: string; label: string }[] = [
  { value: "TRADITIONAL_WOOD_ELECTRIC", label: "Traditional (Wood / Electric)" },
  { value: "INFRARED",                  label: "Infrared" },
  { value: "MOBILE",                    label: "Mobile" },
];

export const SAUNA_TYPE_LABELS: Record<string, string> =
  Object.fromEntries(SAUNA_TYPES.map((t) => [t.value, t.label]));
